import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const sideBarStyles = makeStyles((theme) => ({
    sideBar: {
        marginBottom: theme.spacing(2),

        '& .sidebar': {
            backgroundColor: tcsmColors.greySeven,
            marginBottom: theme.spacing(1),
            padding: theme.spacing(2),
            [theme.breakpoints.down('md')]: {
                padding: theme.spacing(1),
            },
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(2),

            },
            '&-section': {
                '& + .sidebar-section': {
                    borderTop: `1px solid ${tcsmColors.greyFive}`,
                    marginTop: theme.spacing(1.5),
                    paddingTop: theme.spacing(1.5),
                },
            },
            '&-content': {

            },
            '&-link': {
                '& svg': {
                    marginRight: theme.spacing(.5),
                    flex: '0 0 auto',
                },
            },
        },
    },

}));